/**
 * Registry of CoralModelConstructor instances that can be used by serialization utilities to identify an abstract type.
 *
 * CoralModelConstructor instances are de-duped by their `fullyQualifiedTypeName` value.
 */
class ModelRegistry {
    constructor() {
        this.lookupByFullyQualifiedTypeName = new Map();
    }
    /**
     * Add the type to the registry, if it doesn't already exist.
     *
     * @param ctor CoralModelConstructor
     */
    registerType(ctor) {
        const __type = ctor.fullyQualifiedTypeName;
        if (!this.lookupByFullyQualifiedTypeName.has(__type)) {
            this.lookupByFullyQualifiedTypeName.set(__type, ctor);
        }
    }
    /**
     *
     * @param __type string
     * @return the constructor previously registered with the given type name, or undefined if it wasn't previously registered
     */
    getConstructorByTypeName(__type) {
        return this.lookupByFullyQualifiedTypeName.get(__type);
    }
}
// Export a singleton instance of the registry.
export const modelRegistrySingleton = new ModelRegistry();
